import { APP_CONFIG } from './config/appConfig';

export const API_URL = APP_CONFIG.api.baseUrl;

export const config = {
  apiUrl: API_URL,
  endpoints: {
    sendEmail: `${API_URL}/api/send-email`,
  }
};
